import React, {useEffect, useRef, useCallback} from "react";
import {AudioPresets, Track} from "livekit-client";
import {useLocalParticipant} from "@livekit/components-react";
import {useEffectOnce} from "../hooks/useEffectOnce";

function AudioURLPlayback(props) {
    const audioElRef = useRef();
    const audioSourceNodeRef = useRef(null);
    const audioContextRef = useRef(new AudioContext());
    const audioDestinationNodeRef = useRef(null);
    const publishedTrack = useRef(null);
    const {localParticipant} = useLocalParticipant();

    const cleanup = useCallback(() => {
        if (publishedTrack.current) {
            localParticipant.unpublishTrack(publishedTrack.current);
            publishedTrack.current = null;
        }
        if (audioSourceNodeRef.current) {
            audioSourceNodeRef.current.disconnect();
            audioSourceNodeRef.current = null;
        }
        if (audioDestinationNodeRef.current) {
            audioDestinationNodeRef.current.disconnect();
            audioDestinationNodeRef.current = null;
        }
        if (audioElRef.current) {
            audioElRef.current.pause();
            audioElRef.current.remove();
            audioElRef.current = null;
        }
    }, []);

    useEffect(() => {
        if(!props.url) {
            cleanup()
        }

        if (audioElRef.current && props.url) {
            try {
                // Create audio source and store it
                audioElRef.current.volume = 0.4
                audioSourceNodeRef.current = audioContextRef.current.createMediaElementSource(audioElRef.current);

                // Connect audio source node to a MediaStreamAudioDestinationNode
                audioDestinationNodeRef.current = audioContextRef.current.createMediaStreamDestination();
                audioSourceNodeRef.current.connect(audioDestinationNodeRef.current);

                // Publish audio to LiveKit room
                publishedTrack.current = audioDestinationNodeRef.current.stream.getAudioTracks()[0]
                localParticipant.publishTrack(publishedTrack.current, {
                    name: "background_audio",
                    source: Track.Source.ScreenShareAudio,
                    audioPreset: AudioPresets.musicHighQualityStereo,
                    red: false,
                    dtx: false,
                });
            } catch {

            }

        }
    }, [audioElRef.current, props.url]);

    useEffectOnce(() => {
        return cleanup
    })

    return <audio ref={audioElRef}
                  preload="auto"
                  muted={false}
                  loop={true}
                  autoPlay={true}
                  controls={true}
                  style={{
                      width: "430px",
                      marginLeft: "5px",
                      transform:props.isGroupGame ? "scale(0.56) translateX(-172px)" : "scale(0.6) translateX(-142px)"
    }}
    >
        <source src={props.url}/>
    </audio>
}

export default React.memo(AudioURLPlayback)